
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("brb3w", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $7645369fdca85719$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $2oAAJ = parcelRequire("2oAAJ");

var $jcIvM = parcelRequire("jcIvM");

var $cu6g7 = parcelRequire("cu6g7");

var $lF8Fb = parcelRequire("lF8Fb");

var $bAhKB = parcelRequire("bAhKB");

var $lAaBI = parcelRequire("lAaBI");

var $6ilbC = parcelRequire("6ilbC");

var $7Qg5s = parcelRequire("7Qg5s");

var $6fyPV = parcelRequire("6fyPV");

var $6u0MJ = parcelRequire("6u0MJ");

var $8wkwM = parcelRequire("8wkwM");

var $2ZwjF = parcelRequire("2ZwjF");

var $asVFB = parcelRequire("asVFB");

var $7xUzL = parcelRequire("7xUzL");

var $lC5d0 = parcelRequire("lC5d0");

var $jV9Qv = parcelRequire("jV9Qv");

var $2QO3b = parcelRequire("2QO3b");
async function $7645369fdca85719$var$createInteractionExtraLogPayload(interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult) {
    const config = (0, $jcIvM.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    const { end: end, start: start, ufoName: ufoName, rate: rate, type: type, abortReason: abortReason, routeName: routeName, previousInteractionName: previousInteractionName, isPreviousInteractionAborted: isPreviousInteractionAborted, abortedByInteractionName: abortedByInteractionName, knownSegments: knownSegments, minorInteractions: minorInteractions } = interaction;
    const sanitisedUfoName = (0, $cu6g7.sanitizeUfoName)(ufoName);
    const configRate = (0, $jcIvM.getExtraInteractionRate)(sanitisedUfoName, type);
    if (!(0, $2oAAJ.default)(configRate)) return null;
    const pageVisibilityAtTTAI = (0, $bAhKB.default)(interaction);
    const isPageLoad = type === 'page_load' || type === 'transition';
    if (!isPageLoad || minorInteractions !== undefined && minorInteractions.length > 0) // Not send if aborted by minor interaction for now
    // Only create payload for page load
    return null;
    const calculatePageVisibilityFromTheStartOfPageLoad = config.enableBetterPageVisibilityApi && isPageLoad;
    const moreAccuratePageVisibilityAtTTAI = calculatePageVisibilityFromTheStartOfPageLoad ? (0, $lF8Fb.getMoreAccuratePageVisibilityUpToTTAI)(interaction) : null;
    const extraTTAI = (0, $7Qg5s.default)(interaction) ?? undefined;
    const newUFOName = (0, $cu6g7.sanitizeUfoName)(ufoName);
    const finalVCMetrics = await (0, $6fyPV.default)(interaction, true);
    // Check if VC is clean and has valid metric
    const vcRevisionPayload = finalVCMetrics?.['ufo:vc:rev'];
    const effectiveVCRevisionPayload = vcRevisionPayload?.find(({ revision: revision })=>revision === (0, $jcIvM.DEFAULT_TTVC_REVISION));
    if (!effectiveVCRevisionPayload?.clean || effectiveVCRevisionPayload?.['metric:vc90'] === undefined || typeof effectiveVCRevisionPayload?.['metric:vc90'] !== 'number' || extraTTAI === undefined || typeof extraTTAI !== 'number' || interaction.errors.length > 0) return null;
    // Get normal TTAI & VC90 for last finished interaction (without 3p)
    if (!lastInteractionFinish || lastInteractionFinish?.abortReason || lastInteractionFinish?.errors?.length) return null;
    const normalTTAI = (0, $7Qg5s.default)(lastInteractionFinish) ?? undefined;
    const lastInteractionFinishStart = typeof lastInteractionFinish.start === 'number' ? Math.round(lastInteractionFinish.start) : undefined;
    const lastInteractionFinishEnd = typeof lastInteractionFinish.end === 'number' ? Math.round(lastInteractionFinish.end) : undefined;
    let lastInteractionFinishVC90 = null;
    let lastInteractionFinishVCClean = false;
    if (lastInteractionFinishVCResult) {
        const lastInteractionFinishVCRev = lastInteractionFinishVCResult['ufo:vc:rev'];
        const lastInteractionFinishRevision = lastInteractionFinishVCRev?.find(({ revision: revision })=>revision === (0, $jcIvM.DEFAULT_TTVC_REVISION));
        if (lastInteractionFinishRevision?.clean) {
            lastInteractionFinishVCClean = true;
            lastInteractionFinishVC90 = lastInteractionFinishRevision['metric:vc90'];
        } else return null;
    } else if (normalTTAI !== undefined && typeof normalTTAI === 'number' && normalTTAI === extraTTAI) {
        // Because TTAI is equal between with and without 3p, we can assume VC90 is also equal
        lastInteractionFinishVC90 = effectiveVCRevisionPayload?.['metric:vc90'];
        lastInteractionFinishVCClean = effectiveVCRevisionPayload?.clean;
    }
    // Helper function to check if labelStack contains third-party type
    const isThirdParty = (labelStack)=>{
        return labelStack?.some((entry)=>'type' in entry && entry.type === 'third-party') ?? false;
    };
    // Pre-filter 3p data
    const filteredData = {
        errors: interaction.errors.filter((error)=>isThirdParty(error.labelStack)),
        spans: [
            ...interaction.spans,
            ...(0, $2QO3b.interactionSpans)
        ].filter((span)=>isThirdParty(span.labelStack)),
        requestInfo: interaction.requestInfo.filter((req)=>isThirdParty(req.labelStack)),
        customTimings: interaction.customTimings.filter((timing)=>isThirdParty(timing.labelStack)),
        apdex: interaction.apdex.filter((apdex)=>isThirdParty(apdex.labelStack)),
        reactProfilerTimings: interaction.reactProfilerTimings.filter((timing)=>isThirdParty(timing.labelStack)),
        customData: interaction.customData.filter((data)=>isThirdParty(data.labelStack)),
        segments: knownSegments.filter((segment)=>isThirdParty(segment.labelStack)),
        marks: interaction.marks.filter((mark)=>isThirdParty(mark.labelStack))
    };
    // Clear atlaskit spans after filtering
    (0, $2QO3b.interactionSpans).length = 0;
    // Detailed payload
    const getDetailedInteractionMetrics = ()=>{
        return {
            errors: filteredData.errors.map(({ labelStack: labelStack, ...others })=>({
                    ...others,
                    labelStack: labelStack && (0, $cu6g7.optimizeLabelStack)(labelStack, (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type))
                })),
            holdActive: interaction.hold3pActive ? [
                ...interaction.hold3pActive.values()
            ] : [],
            holdInfo: (0, $2ZwjF.optimizeHoldInfo)(interaction.hold3pInfo ?? [], start, (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type)),
            spans: (0, $jV9Qv.optimizeSpans)(filteredData.spans, start, (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type)),
            requestInfo: (0, $lC5d0.optimizeRequestInfo)(filteredData.requestInfo, start, (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type)),
            customTimings: (0, $8wkwM.optimizeCustomTimings)(filteredData.customTimings, start)
        };
    };
    const segments3p = !(0, $eGOwo.fg)('platform_ufo_remove_deprecated_config_fields') && config.killswitchNestedSegments ? [] : filteredData.segments;
    const segmentTree = (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type) === '2.0.0' ? (0, $cu6g7.buildSegmentTree)(segments3p.map((segment)=>segment.labelStack)) : {};
    const payload = {
        actionSubject: 'experience',
        action: 'measured',
        eventType: 'operational',
        source: 'measured',
        tags: [
            'observability'
        ],
        attributes: {
            properties: {
                // basic
                'event:hostname': window.location?.hostname || 'unknown',
                'event:product': config.product,
                'event:schema': '1.0.0',
                'event:sizeInKb': 0,
                'event:source': {
                    name: 'react-ufo/web',
                    version: (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type)
                },
                'event:region': config.region || 'unknown',
                'experience:key': 'custom.interaction-extra-metrics',
                'experience:name': newUFOName,
                interactionMetrics: {
                    namePrefix: config.namePrefix || '',
                    segmentPrefix: config.segmentPrefix || '',
                    interactionId: interactionId,
                    pageVisibilityAtTTAI: pageVisibilityAtTTAI,
                    experimental__pageVisibilityAtTTAI: moreAccuratePageVisibilityAtTTAI,
                    rate: // raw interaction metrics
                    rate,
                    routeName: routeName,
                    type: type,
                    abortReason: abortReason,
                    previousInteractionName: previousInteractionName,
                    isPreviousInteractionAborted: isPreviousInteractionAborted,
                    abortedByInteractionName: abortedByInteractionName,
                    // performance
                    end: Math.round(end),
                    start: Math.round(start),
                    'metric:ttai:3p': extraTTAI,
                    ...finalVCMetrics,
                    segments: (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type) === '2.0.0' ? segmentTree : (0, $cu6g7.getOldSegmentsLabelStack)(segments3p, interaction.type),
                    marks: (0, $asVFB.optimizeMarks)(filteredData.marks, (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type)),
                    apdex: (0, $6u0MJ.optimizeApdex)(filteredData.apdex, (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type)),
                    reactProfilerTimings: (0, $7xUzL.optimizeReactProfilerTimings)(filteredData.reactProfilerTimings, start, (0, $6ilbC.getReactUFOPayloadVersion)(interaction.type)),
                    customData: filteredData.customData,
                    ...getDetailedInteractionMetrics()
                },
                'vc:effective:revision': (0, $jcIvM.DEFAULT_TTVC_REVISION),
                lastInteractionFinish: {
                    start: lastInteractionFinishStart,
                    end: lastInteractionFinishEnd,
                    ttai: normalTTAI,
                    vc90: lastInteractionFinishVC90,
                    vcClean: lastInteractionFinishVCClean
                }
            }
        }
    };
    payload.attributes.properties['event:sizeInKb'] = (0, $lAaBI.default)(payload.attributes.properties);
    return payload;
}
var $7645369fdca85719$export$2e2bcd8739ae039 = $7645369fdca85719$var$createInteractionExtraLogPayload;

});
parcelRegister("lF8Fb", function(module, exports) {
$parcel$export(module.exports, "getMoreAccuratePageVisibilityUpToTTAI", () => $89a2868c4da36fcc$export$97ea55623bd7f1ae);

var $bAhKB = parcelRequire("bAhKB");

var $80wnk = parcelRequire("80wnk");
function $89a2868c4da36fcc$export$97ea55623bd7f1ae(interaction) {
    const old = (0, $bAhKB.default)(interaction);
    const buffered = (0, $80wnk.getVisibilityStateFromPerformance)(interaction.end);
    if (!buffered) return old;
    if (buffered !== old) return 'mixed';
    return old;
}

});
parcelRegister("bAhKB", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad9a42ff7463533a$export$2e2bcd8739ae039);

var $8tW4o = parcelRequire("8tW4o");
function $ad9a42ff7463533a$var$getPageVisibilityUpToTTAI(interaction) {
    const { start: start, end: end } = interaction;
    return (0, $8tW4o.getPageVisibilityState)(start, end);
}
var $ad9a42ff7463533a$export$2e2bcd8739ae039 = $ad9a42ff7463533a$var$getPageVisibilityUpToTTAI;

});

parcelRegister("80wnk", function(module, exports) {
$parcel$export(module.exports, "getVisibilityStateFromPerformance", () => $42175de33f566036$export$bcaa23184870682a);
function $42175de33f566036$export$bcaa23184870682a(stop) {
    try {
        const results = performance.getEntriesByType('visibility-state');
        if (!results || results.length === 0) return null;
        // @ts-ignore
        return results.reduce((acc = null, { name: name, startTime: startTime })=>{
            if (startTime > stop) return acc;
            if (acc === null && name === null) return null;
            if (acc === null) return name;
            if (acc !== name) return 'mixed';
            return acc;
        }, null);
    } catch (e) {
        return null;
    }
}

});


parcelRegister("lAaBI", function(module, exports) {
$parcel$export(module.exports, "default", () => $789f3ac5021170c5$export$2e2bcd8739ae039);
// Reusable TextEncoder instance to avoid creating new instances
const $789f3ac5021170c5$var$textEncoder = new TextEncoder();
function $789f3ac5021170c5$export$2e2bcd8739ae039(payload) {
    // Early return for null/undefined to avoid unnecessary processing
    if (!payload) return 0;
    // Use the reusable encoder instance
    return Math.round($789f3ac5021170c5$var$textEncoder.encode(JSON.stringify(payload)).length / 1024);
}

});

parcelRegister("7Qg5s", function(module, exports) {
$parcel$export(module.exports, "default", () => $d868487c9246c209$export$2e2bcd8739ae039);

var $bAhKB = parcelRequire("bAhKB");
function $d868487c9246c209$export$2e2bcd8739ae039(interaction) {
    const { start: start, end: end } = interaction;
    const pageVisibilityUpToTTAI = (0, $bAhKB.default)(interaction);
    return !interaction.abortReason && pageVisibilityUpToTTAI === 'visible' ? Math.round(end - start) : undefined;
}

});

parcelRegister("6fyPV", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e1fb95f22ef955b$export$2e2bcd8739ae039);

var $2oAAJ = parcelRequire("2oAAJ");

var $jcIvM = parcelRequire("jcIvM");

var $2QO3b = parcelRequire("2QO3b");

var $jvGVe = parcelRequire("jvGVe");

var $bAhKB = parcelRequire("bAhKB");

var $hmVXh = parcelRequire("hmVXh");
async function $3e1fb95f22ef955b$var$getVCMetrics(interaction, include3p = false, excludeSmartAnswersInSearch = false) {
    const config = (0, $jcIvM.getConfig)();
    if (!config?.vc?.enabled) return {};
    if (interaction.type !== 'page_load' && interaction.type !== 'transition' && interaction.type !== 'press') return {};
    const interactionStatus = (0, $jvGVe.default)(interaction);
    const pageVisibilityUpToTTAI = (0, $bAhKB.default)(interaction);
    const isPageVisible = pageVisibilityUpToTTAI === 'visible';
    const shouldReportVCMetrics = interactionStatus.originalInteractionStatus === 'SUCCEEDED' && isPageVisible;
    // Use per-interaction VC observer if available, otherwise fall back to global
    const observer = interaction.vcObserver;
    if (!observer) return {};
    const includeRawData = (0, $2oAAJ.default)((0, $jcIvM.getVCRawDataInteractionRate)(interaction.ufoName, interaction.type));
    const isSSREnabled = interaction.type === 'page_load' && (config?.ssr || config?.vc.ssrWhitelist?.includes(interaction.ufoName));
    const ssr = interaction.type === 'page_load' && isSSREnabled ? {
        ssr: (0, $hmVXh.default)(config)
    } : null;
    (0, $2QO3b.postInteractionLog).setVCObserverSSRConfig(ssr);
    const tti = interaction.apdex?.[0]?.stopTime;
    const prefix = 'ufo';
    const result = await observer.getVCResult({
        start: interaction.start,
        stop: interaction.end,
        tti: tti,
        prefix: prefix,
        includeSSRInV3: config.vc?.includeSSRInV3,
        vc: interaction.vc,
        isEventAborted: interactionStatus.originalInteractionStatus !== 'SUCCEEDED',
        experienceKey: interaction.ufoName,
        interactionId: interaction.id,
        includeSSRRatio: config.vc?.includeSSRRatio,
        ...ssr,
        include3p: include3p,
        excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
        interactionType: interaction.type,
        isPageVisible: isPageVisible,
        includeRawData: includeRawData
    });
    observer.stop(interaction.ufoName);
    if (!include3p) {
        // For Post Interaction, last interaction should be without 3p
        (0, $2QO3b.postInteractionLog).setLastInteractionFinishVCResult(result);
        (0, $2QO3b.interactionExtraMetrics).setLastInteractionFinishVCResult(result);
    }
    const mostRecentVCRevision = (0, $jcIvM.getMostRecentVCRevision)(interaction.ufoName);
    const mostRecentVCRevisionPayload = result?.['ufo:vc:rev']?.find(({ revision: revision })=>revision === mostRecentVCRevision);
    if (!shouldReportVCMetrics || !mostRecentVCRevisionPayload?.clean) return result;
    return {
        ...result,
        'metric:vc90': mostRecentVCRevisionPayload['metric:vc90']
    };
}
var $3e1fb95f22ef955b$export$2e2bcd8739ae039 = $3e1fb95f22ef955b$var$getVCMetrics;

});
parcelRegister("jvGVe", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f7e882a6836f5e2$export$2e2bcd8739ae039);
function $8f7e882a6836f5e2$var$getInteractionStatus(interaction) {
    let originalInteractionStatus = interaction.abortReason ? 'ABORTED' : 'SUCCEEDED';
    const hasErrors = interaction.errors.length > 0;
    originalInteractionStatus = hasErrors ? 'FAILED' : originalInteractionStatus;
    // `overrideStatus` is to be deprecated - https://product-fabric.atlassian.net/browse/AFO-3760
    return {
        originalInteractionStatus: originalInteractionStatus,
        overrideStatus: originalInteractionStatus
    };
}
var $8f7e882a6836f5e2$export$2e2bcd8739ae039 = $8f7e882a6836f5e2$var$getInteractionStatus;

});

parcelRegister("hmVXh", function(module, exports) {
$parcel$export(module.exports, "default", () => $18931377f064fcc6$export$2e2bcd8739ae039);

var $gA3op = parcelRequire("gA3op");
function $18931377f064fcc6$var$getSSRDoneTimeValue(config) {
    return config?.ssr?.getSSRDoneTime ? config?.ssr?.getSSRDoneTime() : $gA3op.getSSRDoneTime();
}
var $18931377f064fcc6$export$2e2bcd8739ae039 = $18931377f064fcc6$var$getSSRDoneTimeValue;

});
parcelRegister("gA3op", function(module, exports) {
$parcel$export(module.exports, "configure", () => $b65e54b4ec190147$export$8d21e34596265fa2);
$parcel$export(module.exports, "getEdgeTimingsIncludingCloudfront", () => $b65e54b4ec190147$export$5300d1b82e594615);
$parcel$export(module.exports, "getSSRTimings", () => $b65e54b4ec190147$export$bf7408e83532dcd0);
$parcel$export(module.exports, "getSSRSuccess", () => $b65e54b4ec190147$export$c7ad864055e75537);
$parcel$export(module.exports, "getSSRPhaseSuccess", () => $b65e54b4ec190147$export$5eade9354185583d);
$parcel$export(module.exports, "getSSRDoneTime", () => $b65e54b4ec190147$export$3def7672244bab0c);
$parcel$export(module.exports, "getSSRFeatureFlags", () => $b65e54b4ec190147$export$1c4a9b5e6e22393d);
const $b65e54b4ec190147$var$NESTED_METRIC_SEPARATOR = '/';
function $b65e54b4ec190147$var$filterEntry(entry) {
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
}
function $b65e54b4ec190147$var$mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration),
        ...entry.size ? {
            size: Math.round(entry.size)
        } : {}
    };
}
const $b65e54b4ec190147$var$SSR_PREFIX = 'ssr';
function $b65e54b4ec190147$var$mapKey(key) {
    if (key === 'total') return $b65e54b4ec190147$var$SSR_PREFIX;
    return `${$b65e54b4ec190147$var$SSR_PREFIX}${$b65e54b4ec190147$var$NESTED_METRIC_SEPARATOR}${key}`;
}
let $b65e54b4ec190147$var$config;
function $b65e54b4ec190147$export$8d21e34596265fa2(ssrConfig) {
    $b65e54b4ec190147$var$config = ssrConfig;
}
function $b65e54b4ec190147$var$getPerformanceNavigationTiming() {
    // getEntriesByType doesn't change the returned type based on the given type key
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return performance.getEntriesByType('navigation')?.[0];
}
function $b65e54b4ec190147$var$getServerTimingsByName() {
    const serverTimingsByName = Object.fromEntries($b65e54b4ec190147$var$getPerformanceNavigationTiming()?.serverTiming?.map((timing)=>[
            timing.name,
            timing
        ]) ?? []);
    return serverTimingsByName;
}
/**
 * If we have the edge's view of ttfb and the clients view as well, then we should take the gap between them as
 * the offset to use foe edge start time.
 * This will simulate the network delays between the client and the edge as an edge startTime increase
 */ function $b65e54b4ec190147$var$getEdgeOffset(edgeTtfb) {
    const clientTtfb = $b65e54b4ec190147$var$getPerformanceNavigationTiming()?.responseStart;
    if (edgeTtfb == null || clientTtfb == null) return 0;
    return clientTtfb - edgeTtfb;
}
function $b65e54b4ec190147$export$5300d1b82e594615() {
    const serverTimingsByName = $b65e54b4ec190147$var$getServerTimingsByName();
    const edgeTotalDuration = serverTimingsByName['cdn-downstream-fbl']?.duration ?? serverTimingsByName['atl-edge']?.duration;
    if (!edgeTotalDuration) return null;
    const edgeOffset = $b65e54b4ec190147$var$getEdgeOffset(edgeTotalDuration);
    const cfInternalDuration = (serverTimingsByName['cdn-upstream-dns']?.duration || 0) + (serverTimingsByName['cdn-upstream-connect']?.duration || 0);
    const cfUpstreamDuration = (serverTimingsByName['cdn-upstream-fbl']?.duration || 0) - cfInternalDuration;
    const cfDownstreamDuration = (serverTimingsByName['cdn-downstream-fbl']?.duration || 0) - (serverTimingsByName['cdn-upstream-fbl']?.duration || 0);
    const atlEdgeDuration = serverTimingsByName['atl-edge']?.duration;
    const cfToAtlEdgeNetworkDuration = cfUpstreamDuration - atlEdgeDuration;
    const edgeTimings = {
        edge: {
            startTime: edgeOffset,
            duration: edgeTotalDuration
        }
    };
    if (typeof serverTimingsByName['cdn-downstream-fbl'] !== 'undefined') {
        edgeTimings['edge/cf'] = {
            startTime: edgeOffset,
            duration: serverTimingsByName['cdn-downstream-fbl']?.duration
        };
        edgeTimings['edge/cf/internal'] = {
            startTime: edgeOffset,
            duration: cfInternalDuration
        };
        edgeTimings['edge/cf/upstream'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfUpstreamDuration
        };
        edgeTimings['edge/cf/downstream'] = {
            startTime: edgeOffset + cfInternalDuration + cfUpstreamDuration,
            duration: cfDownstreamDuration
        };
    }
    if (typeof serverTimingsByName['atl-edge'] !== 'undefined') {
        edgeTimings['edge/atl-edge'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/atl-edge/internal'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: serverTimingsByName['atl-edge-internal']?.duration
        };
        edgeTimings['edge/atl-edge/ttfb'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/cf/upstream/network'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfToAtlEdgeNetworkDuration
        };
    }
    // we need a timer here to prevent UFO pipeline from shifting SSR timers to start at 0
    edgeTimings?.edge && edgeOffset && Object.assign(edgeTimings, {
        'client-network': {
            startTime: 0,
            duration: edgeOffset
        }
    });
    return edgeTimings;
}
function $b65e54b4ec190147$export$bf7408e83532dcd0() {
    const defaultSSRTimings = $b65e54b4ec190147$export$5300d1b82e594615() || {};
    let configTimings = {};
    if (typeof $b65e54b4ec190147$var$config?.getTimings === 'function') configTimings = $b65e54b4ec190147$var$config.getTimings();
    const ssrTimings = Object.entries({
        ...configTimings,
        ...defaultSSRTimings
    }).reduce((acc, entry)=>{
        if ($b65e54b4ec190147$var$filterEntry(entry[1])) acc[$b65e54b4ec190147$var$mapKey(entry[0])] = $b65e54b4ec190147$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $b65e54b4ec190147$export$c7ad864055e75537() {
    return !!$b65e54b4ec190147$var$config?.getDoneMark();
}
function $b65e54b4ec190147$export$5eade9354185583d() {
    return $b65e54b4ec190147$var$config?.getSsrPhaseSuccess?.();
}
function $b65e54b4ec190147$export$3def7672244bab0c() {
    return $b65e54b4ec190147$var$config?.getDoneMark() ?? undefined;
}
function $b65e54b4ec190147$export$1c4a9b5e6e22393d() {
    if (!$b65e54b4ec190147$var$config?.getFeatureFlags) return undefined;
    try {
        return $b65e54b4ec190147$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch  {}
    return undefined;
}

});



parcelRegister("6u0MJ", function(module, exports) {
$parcel$export(module.exports, "optimizeApdex", () => $fe23856db1e8df23$export$efbacb487c03c9c8);

var $cu6g7 = parcelRequire("cu6g7");
function $fe23856db1e8df23$export$efbacb487c03c9c8(apdex, reactUFOVersion) {
    return apdex.map(({ stopTime: stopTime, labelStack: labelStack, ...others })=>({
            ...others,
            stopTime: Math.round(stopTime),
            ...labelStack ? {
                labelStack: (0, $cu6g7.optimizeLabelStack)(labelStack, reactUFOVersion)
            } : {}
        }));
}

});

parcelRegister("8wkwM", function(module, exports) {
$parcel$export(module.exports, "optimizeCustomTimings", () => $26fb4666761553df$export$967dd9693261321d);
function $26fb4666761553df$export$967dd9693261321d(customTimings, interactionStart) {
    return customTimings.reduce((result, item)=>{
        Object.keys(item.data).forEach((key)=>{
            if (item.data[key].startTime >= interactionStart) result.push({
                labelStack: [
                    {
                        n: key
                    }
                ],
                startTime: Math.round(item.data[key].startTime),
                endTime: Math.round(item.data[key].endTime)
            });
        });
        return result;
    }, []);
}

});

parcelRegister("2ZwjF", function(module, exports) {
$parcel$export(module.exports, "optimizeHoldInfo", () => $2e2cbd3cf3e2a37f$export$b983e6c30f3a8c82);

var $cu6g7 = parcelRequire("cu6g7");
function $2e2cbd3cf3e2a37f$export$b983e6c30f3a8c82(holdInfo, interactionStart, reactUFOVersion) {
    const holdInfoMap = holdInfo.reduce((result, hold)=>{
        const { labelStack: labelStack, name: name, start: start, end: end, ignoreOnSubmit: ignoreOnSubmit } = hold;
        if (labelStack && !ignoreOnSubmit && start >= interactionStart) {
            const label = (0, $cu6g7.stringifyLabelStackFully)([
                ...labelStack,
                {
                    name: name
                }
            ]);
            const startTime = Math.round(start);
            const endTime = Math.round(end);
            const timing = result.get(label) || {
                labelStack: (0, $cu6g7.optimizeLabelStack)([
                    ...labelStack,
                    {
                        name: name
                    }
                ], reactUFOVersion),
                startTime: startTime,
                endTime: endTime
            };
            if (startTime < timing.startTime) timing.startTime = startTime;
            if (endTime > timing.endTime) timing.endTime = endTime;
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return [
        ...holdInfoMap.values()
    ];
}

});

parcelRegister("asVFB", function(module, exports) {
$parcel$export(module.exports, "optimizeMarks", () => $0f6b91d2af9f832f$export$4f8106ecc7ec1c7f);

var $cu6g7 = parcelRequire("cu6g7");
function $0f6b91d2af9f832f$export$4f8106ecc7ec1c7f(marks, reactUFOVersion) {
    return marks.map(({ labelStack: labelStack, time: time, ...others })=>({
            ...others,
            labelStack: labelStack && (0, $cu6g7.optimizeLabelStack)(labelStack, reactUFOVersion),
            time: Math.round(time)
        }));
}

});

parcelRegister("7xUzL", function(module, exports) {
$parcel$export(module.exports, "optimizeReactProfilerTimings", () => $b152f42dbc86009c$export$70a658ddbf644d3a);

var $eGOwo = parcelRequire("eGOwo");

var $2QO3b = parcelRequire("2QO3b");

var $cu6g7 = parcelRequire("cu6g7");
function $b152f42dbc86009c$export$70a658ddbf644d3a(reactProfilerTimings, interactionStart, reactUFOVersion) {
    const reactProfilerTimingsMap = reactProfilerTimings.reduce((result, { labelStack: labelStack, startTime: startTime, commitTime: commitTime, actualDuration: actualDuration, type: type })=>{
        if (labelStack && startTime >= interactionStart) {
            const label = (0, $cu6g7.stringifyLabelStackFully)(labelStack);
            const start = Math.round(startTime);
            const end = Math.round(commitTime);
            const timing = result.get(label) || {
                labelStack: (0, $cu6g7.optimizeLabelStack)(labelStack, reactUFOVersion),
                startTime: start,
                endTime: end,
                mountCount: 0,
                rerenderCount: 0,
                renderDuration: 0
            };
            if (start < timing.startTime) timing.startTime = start;
            if (end > timing.endTime) timing.endTime = end;
            if (type === 'mount') timing.mountCount += 1;
            if (type === 'update') timing.rerenderCount += 1;
            if ((0, $2QO3b.segmentUnmountCache).has(label) && (0, $eGOwo.fg)('platform_ufo_segment_unmount_count')) {
                timing.unmountCount = (0, $2QO3b.segmentUnmountCache).get(label) || 0;
                (0, $2QO3b.segmentUnmountCache).delete(label);
            }
            timing.renderDuration += Math.round(actualDuration);
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return [
        ...reactProfilerTimingsMap.values()
    ];
}

});

parcelRegister("lC5d0", function(module, exports) {
$parcel$export(module.exports, "optimizeRequestInfo", () => $52a0463c3b0966fd$export$9b2c740f95fe352d);

var $cu6g7 = parcelRequire("cu6g7");
function $52a0463c3b0966fd$export$9b2c740f95fe352d(requestInfo, interactionStart, reactUFOVersion) {
    const updatedRequestInfo = requestInfo.reduce((result, reqInfo)=>{
        const { labelStack: labelStack, name: name, start: start, end: end, networkStart: networkStart, networkComplete: networkComplete } = reqInfo;
        const startTime = networkStart ?? start;
        const endTime = networkComplete ?? end;
        if (labelStack && start >= interactionStart && endTime) result.push({
            labelStack: (0, $cu6g7.optimizeLabelStack)([
                ...labelStack,
                {
                    name: name
                }
            ], reactUFOVersion),
            startTime: Math.round(startTime),
            endTime: Math.round(endTime)
        });
        return result;
    }, []);
    return updatedRequestInfo;
}

});

parcelRegister("jV9Qv", function(module, exports) {
$parcel$export(module.exports, "optimizeSpans", () => $07359abd17ace965$export$e69673407fa1f9ed);

var $cu6g7 = parcelRequire("cu6g7");
function $07359abd17ace965$export$e69673407fa1f9ed(spans, interactionStart, reactUFOVersion) {
    const updatedSpans = spans.reduce((result, span)=>{
        const { labelStack: labelStack, type: type, name: name, start: start, end: end } = span;
        if (labelStack && start >= interactionStart) result.push({
            labelStack: (0, $cu6g7.optimizeLabelStack)([
                ...labelStack,
                {
                    name: name
                }
            ], reactUFOVersion),
            startTime: Math.round(start),
            endTime: Math.round(end),
            type: type
        });
        return result;
    }, []);
    return updatedSpans;
}

});



//# sourceMappingURL=create-interaction-extra-metrics-payload.2f8bc445.js.map
